import { Box, SegmentGroup, Text, useBreakpointValue } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LISTING_CATEGORIES } from '../../../containers/EditListingPage/listingTypeConfig';

const categories = [
  { label: 'Everything', value: 'all' },
  ...Object.values(LISTING_CATEGORIES).map(category => ({
    label: category.pluralLabel,
    value: category.id,
  })),
];

const QUERY_KEY = 'pub_categoryLevel1';

const parseCategoryFromUrl = search => {
  const params = new URLSearchParams(search);
  const category = params.get(QUERY_KEY);

  return category ? category : 'all';
};

const CategorySpecificFilters = ({ updateQueryParams, showHeader: inPopUp }) => {
  const orientation = useBreakpointValue({
    base: 'vertical',
    md: 'horizontal',
  });
  const location = useLocation();

  const [category, setCategory] = useState(() => parseCategoryFromUrl(location.search));

  useEffect(() => {
    const fromUrl = parseCategoryFromUrl(location.search);
    setCategory(fromUrl);
  }, [location.search]);

  const handleChange = ({ value: category }) => {
    setCategory(category);

    updateQueryParams({
      [QUERY_KEY]: category === 'all' ? null : category,
    });
  };

  return (
    <Box pt={0}>
      <SegmentGroup.Root
        size={'lg'}
        defaultValue={'all'}
        value={category} // local state for instant response
        onValueChange={handleChange}
        orientation={orientation}
        w="100%"
        bgColor={'white'}
        rounded={inPopUp ? 'xl' : '3xl'}
      >
        <SegmentGroup.Indicator
          bgColor={'gray.50'}
          borderWidth={'0.125rem'}
          borderColor={'gray.900'}
          rounded={inPopUp ? 'xl' : '3xl'}
        />
        <SegmentGroup.Items
          items={categories}
          fontWeight="medium"
          rounded={inPopUp ? 'xl' : '3xl'}
          w={'100%'}
          textWrap={'noWrap'}
          whiteSpace={'noWrap'}
          scrollSnapAlign="start"
          cursor="pointer"
        />
      </SegmentGroup.Root>
    </Box>
  );
};

export default CategorySpecificFilters;
